import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import CloseIcon from "@/components/icons/CloseIcon";
import { useClient } from "@/hooks/useClient";

const TopHeader = () => {
  const { locale } = useRouter();
  const { isClient } = useClient();

  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    setIsIOS(
      userAgent.indexOf("iphone") > -1 ||
        userAgent.indexOf("ipad") > -1 ||
        userAgent.indexOf("ipod") > -1
    );
  }, []);

  const [active, setActive] = useState(
    typeof window !== "undefined" && window.sessionStorage.getItem("mobile-app")
  );
  useEffect(() => {
    if (!active) {
      setActive(true);
      window.sessionStorage.setItem("mobile-app", "true");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={`${
        active && isClient ? "flex sm:hidden" : "hidden"
      }  bg-white py-2 px-3 items-center justify-between relative z-header`}
    >
      <div className="flex w-full items-center justify-center text-secondary-900">
        <p className="font-bold text-secondary-900 uppercase max-sm:text-xs">
          {locale === "en"
            ? "Download the app for the best offers"
            : "حمل التطبيق لتجربة شراء أفضل"}
        </p>
        <button
          aria-label="Mobile App Download button"
          className="mx-3 border border-secondary-900 text-secondary-900 px-3 py-1.5 rounded-md max-sm:text-xs"
          onClick={() =>
            window.open(
              isIOS
                ? "https://apps.apple.com/sa/app/abdulwahed-shopping-app/id1548762547"
                : "https://play.google.com/store/apps/details?id=com.abdulwahed&hl=en_US&gl=US"
            )
          } // need deep link
        >
          {locale === "en" ? "Install now" : "حمل التطبيق"}
        </button>
      </div>
      <CloseIcon
        onClick={() => {
          setActive(false);
          if (typeof window !== "undefined") {
            window.sessionStorage.setItem("mobile-app", "false");
          }
        }}
        className="text-white cursor-pointer size-4 max-sm:size-3"
      />
    </div>
  );
};

export default TopHeader;
